import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: { merchantId: 1 } },
	sign: 'dafdsf'
}

// 跟新app
export function updateapp (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/android/update/saveUpdateApp',
		method: 'post',
		data: obj
	})
}

// 获取app版本
export function getappversion (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/android/update/getnowappversion',
		method: 'get',
		params: obj
	})
}
